import COUNTRIES from '../countries.translations'

import translations from './potassium.content'
import type { Metal } from './types'

const t = translations
const dir = '/mine-my-phone/images/metals/potassium'

export const potassium: Metal = {
  id: 30,
  slug: 'potassium',
  name: t.name,
  symbol: 'K',
  // Coordinates geocoded from the sheet's place names.
  mines: [
    {
      name: 'Esterhazy, potassium mine (Canada)',
      region: t.mine0Region,
      slug: 'esterhazy',
      coordinates: [-102.08, 50.66],
    },
    {
      name: 'Rocanville, potassium mine (Canada)',
      region: t.mine1Region,
      slug: 'rocanville',
      coordinates: [-101.68, 50.42],
    },
    {
      name: 'Soligorsk, potassium mine (Belarus)',
      region: t.mine2Region,
      slug: 'soligorsk',
      coordinates: [27.54, 52.79],
    },
    {
      name: 'Solikamsk, potassium mine (Russia)',
      region: t.mine3Region,
      slug: 'solikamsk',
      coordinates: [56.77, 59.63],
    },
    {
      name: 'Berezniki, potassium mine (Russia)',
      region: t.mine4Region,
      slug: 'berezniki',
      coordinates: [56.78, 59.42],
    },
  ],
  countries: [
    { name: COUNTRIES.canada, percent: 31.3 },
    { name: COUNTRIES.russia, percent: 18.8 },
    { name: COUNTRIES.belarus, percent: 14.6 },
    { name: COUNTRIES.china, percent: 13.1 },
    { name: COUNTRIES.germany, percent: 6.3 },
    { name: COUNTRIES.israel, percent: 5 },
  ],
  content: {
    smartphone: {
      quantityScore: 2,
      quantityLabel: t.smartphone.label,
      parts: ['screen'],
    },
    whatItDoes: t.whatItDoes,
    extraction: t.extraction,
    quickFact: t.quickFact,
    impacts: {
      environmental: { severity: null, ...t.impacts.environmental },
      human: { severity: 1, ...t.impacts.human },
      geopolitical: { severity: 3, ...t.impacts.geopolitical },
    },
    supplyRisk: { score: 1, ...t.supplyRisk },
    recycling: { score: 1, ...t.recycling },
    footnotes: t.footnotes,
    photos: {
      hero: {
        src: `${dir}/01.jpg`,
        orientation: 'horizontal',
      },
      firstBento: [
        {
          src: `${dir}/02.jpg`,
          orientation: 'vertical',
        },
        {
          src: `${dir}/03.jpg`,
          orientation: 'vertical',
        },
        {
          src: `${dir}/04.jpg`,
          orientation: 'horizontal',
        },
      ],
    },
  },
}
